import { Directive, Input, OnInit, AfterViewInit,  ElementRef, NgZone, Injector } from '@angular/core';
import { ControlValueAccessor, FormControl, Validators, NgControl } from '@angular/forms';

declare const grecaptcha

declare global 
{
	interface Window {
    grecaptcha : any;
    reCaptchaLoad : () => void
  }
}

export interface RecaptchaConfig
{
	theme? : 'dark' | 'light';
	type? : 'audio' | 'image';
	size? : 'compact' | 'normal';
	tabindex? : number;
}

@Directive({
  selector: '[cls-recaptcha]'
})
export class RecaptchaDirective implements OnInit, AfterViewInit, ControlValueAccessor
{
	@Input() key: string;
	@Input() config: RecaptchaConfig = {};
	@Input() lang: string;

	private _id: number;

	private _onChange: ( value : string ) => void;
  private _onTouched: ( value : string ) => void;

  private _control: FormControl;

	constructor( private _element: ElementRef, private _ngZone: NgZone, private _injector: Injector ) { }

  ngOnInit() 
  {
  	// this.registerReCaptchaCallback();
    // this.addScript();
  }

  ngAfterViewInit() {
    //this._control = this._injector.get(NgControl).control;
    this._setValidator();
  }

  private _setValidator() {
    this._control.setValidators(Validators.required);
    this._control.updateValueAndValidity();
  }

  private _render(_element: HTMLElement, config) : number 
  {
  	return grecaptcha.render(_element, config);
  }

  registerReCaptchaCallback() 
  {
  	// (<any>window).reCaptchaLoad
  	window.reCaptchaLoad = () => {
  		const config = {
  			...this.config,
  			'sitekey': this.key,
  			'callback': this.onSuccess.bind(this),
        'expired-callback': this.onExpired.bind(this)
  		};

  		this._id = this._render(this._element.nativeElement, config);
  	};  	 
  }

  writeValue( obj : any ) : void 
  {
  }

  registerOnChange( fn : any ) : void 
  {
    this._onChange = fn;
  }

  registerOnTouched( fn : any ) : void 
  {
    this._onTouched = fn;
  }

  onExpired() {
    this._ngZone.run(() => {
      this._onChange(null);
      this._onTouched(null);
    });
  }

	onSuccess( token : string ) {
	  this._ngZone.run(() => {
	    this._onChange(token);
	    this._onTouched(token);
	  });
	}

	addScript() 
	{
		let script = document.createElement('script');
		const lang = this.lang ? '&hl=' + this.lang : '';
    script.src = `https://www.google.com/recaptcha/api.js?onload=reCaptchaLoad&render=explicit${lang}`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
	}

}
